/**
 * Карточка «Как проходить акселератор» на главной кабинета.
 *
 * 6-шаговая дорожная карта, синхронизированная по содержанию с
 * `backend/src/drafter/onboarding/roadmap.py` (TG-команда /roadmap +
 * outbox после ENROLLED). По умолчанию свёрнута — занимает одну строку,
 * раскрывается по клику.
 */

import { useState } from 'react';

interface Step {
  title: string;
  body: string;
}

const STEPS: Step[] = [
  {
    title: '1. Зайди в бота',
    body: 'Скринер из 4–5 вопросов. По «правильным» ответам бот зачисляет в поток.',
  },
  {
    title: '2. Открой кабинет',
    body: 'Жми «Log in with Telegram» — один клик и ты внутри.',
  },
  {
    title: '3. Заполни «Карточку идеи»',
    body: 'Ниша. Аудитория. Боль. Цель по выручке. Срок. Контекст для всех 8 модулей.',
  },
  {
    title: '4. Пройди Модуль 1',
    body: 'Открыт всем зачисленным — бесплатно. Чтение → практика → самопроверка → ДЗ.',
  },
  {
    title: '5. Оплати доступ к Модулям 2–8',
    body: '5 500 ₽ через ЮКассу на странице оплаты. Разово, не подписка.',
  },
  {
    title: '6. Двигайся модуль за модулем',
    body: 'Чтение → практика → ДЗ → проверка → следующий модуль.',
  },
];

export function RoadmapCard() {
  const [open, setOpen] = useState(false);
  return (
    <section className="mb-6 overflow-hidden rounded-2xl bg-white dark:bg-slate-900 ring-1 ring-slate-200 dark:ring-slate-800">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left transition hover:bg-slate-50 dark:hover:bg-slate-800/60"
        aria-expanded={open}
      >
        <div>
          <p className="text-[10px] font-medium uppercase tracking-widest text-brand-700 dark:text-brand-300">
            Дорожная карта
          </p>
          <p className="mt-0.5 text-base font-semibold text-slate-900 dark:text-slate-100">
            Как проходить акселератор
          </p>
        </div>
        <span
          className={`shrink-0 text-slate-400 transition-transform duration-200 ${
            open ? 'rotate-180' : ''
          }`}
          aria-hidden
        >
          ▾
        </span>
      </button>
      {open && (
        <ol className="divide-y divide-slate-100 dark:divide-slate-800 border-t border-slate-100 dark:border-slate-800">
          {STEPS.map((s) => (
            <li key={s.title} className="px-5 py-3">
              <p className="font-medium text-slate-900 dark:text-slate-100">{s.title}</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{s.body}</p>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
